import type { QueryClient } from '@tanstack/react-query'
import type { DashboardStatsFilterParams } from '@/shared/api/types'
import { useQuery } from '@tanstack/react-query'
import { getDashboardStats, getRecentActivity } from '@/shared/api/services/dashboard-service'
import { AdminScopeType } from '@/shared/constants'

export const DASHBOARD_QUERY_KEYS = {
  all: ['dashboard'] as const,
  stats: (tenantId: string, params: DashboardStatsFilterParams, scopeType: AdminScopeType) =>
    [...DASHBOARD_QUERY_KEYS.all, 'stats', tenantId, scopeType, params] as const,
  activity: (tenantId: string) => [...DASHBOARD_QUERY_KEYS.all, 'activity', tenantId] as const,
}

/** Vô hiệu mọi cache thống kê dashboard sau khi entity (poi/tour/destination/tenant-destination/tenant) thay đổi. */
export function invalidateDashboardQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: DASHBOARD_QUERY_KEYS.all })
}

export function useDashboardStatsQuery(
  tenantId: string,
  params: DashboardStatsFilterParams = {},
  scopeType: AdminScopeType = AdminScopeType.Super,
) {
  return useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.stats(tenantId, params, scopeType),
    queryFn: async () => getDashboardStats(params),
    enabled: !!tenantId,
  })
}

export function useRecentActivityQuery(tenantId: string) {
  return useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.activity(tenantId),
    queryFn: async () => getRecentActivity(),
    enabled: !!tenantId,
  })
}
